module.exports = __webpack_public_path__ + "static/media/OBCB02.22156841.jpg";